export default __webpack_public_path__ + "static/media/(28).28e5518a.jpg";